import React, { useContext, useEffect, useState } from "react";
import BizinBackend from "../../../../helpers/bizin_helper";
import TableSimple from "../../../../components/Dynamic/TableSimple";
import useGetCsrfToken from "../../../../Hooks/useGetCsrfToken";
import { useSelector } from "react-redux";
import { DF_MO0007Context } from "../context";
import CardFlow from "../../../../components/Common/CardFlow";
import CardContext from "../../../../components/Common/CardContext";

const MAX_SELECTION = 2;

function GridBody() {
  const { user, access_token, isModalPage } = useSelector((state) => ({
    user: state.login.profile,
    access_token: state.login.user.access_token,
    isModalPage: state.Layout.isModalPage
  }));

  const csrfToken = useGetCsrfToken();
  const [step, setStep] = useState(1);
  const [dataStepOne, setdataStepOne] = useState([]);
  const [dataStepTwo, setdataStepTwo] = useState({ pedido: [], itens: [] });
  const [rowSelected, setRowSelected] = useState([]);

  const [flowData, setFlowData] = useState([]);
  const [contextData, setContextData] = useState([]);

  const [hover, setHover] = useState(false);

  const { parseParams } = useContext(DF_MO0007Context);
  const ID_Arquivo = parseParams.get("ID_Arquivo");

  const handleGetDataStepOne = async () => {
    try {
      const resp = await BizinBackend.executeProcedure(
        {
          1: ID_Arquivo,
          2: user.ID_Usuario,
        },
        "SRM_Historico_Get_Lista_Pedidos",
        csrfToken,
        access_token,
      );

      if (resp && resp.length > 0) {
        resp.map((item) => {
          if (item.Data_Criacao)
            item.Data_Criacao = new Date(item.Data_Criacao)
              .toLocaleString()
              .replace(",", " ");
          if (item.Valor_Total_Pedido)
            item.Valor_Total_Pedido = item.Valor_Total_Pedido.toLocaleString(
              "pt-BR",
              { style: "currency", currency: "BRL" },
            );
        });
        setdataStepOne(resp);
      } else {
        setdataStepOne([]);
      }
    } catch (error) {
      console.log("error ao carregar step 1", error);
    }
  };

  const handleGetFlow = async () => {
    try {
      const resp = await BizinBackend.executeProcedure(
        { 1: ID_Arquivo },
        "FRONT_Workspace_Bloco_Fluxo",
        csrfToken,
        access_token,
      );

      const result =
        resp?.data?.resultset_1 ||
        resp?.resultset_1 ||
        (Array.isArray(resp) ? resp : []);

      const formattedFlow = result.map((item) => ({
        name: item.Nome_Empresa,
        description: item.Descricao,
        logo: item.Logo,
      }));

      setFlowData(formattedFlow);
    } catch (error) {
      console.log("erro ao carregar fluxo", error);
    }
  };

  const handleGetContext = async () => {
    const resp = await BizinBackend.executeProcedure(
      { 1: ID_Arquivo },
      "FRONT_Workspace_Bloco_Contexto_Compara_Versoes",
      csrfToken,
      access_token,
    );

    const result = Array.isArray(resp) ? resp : [];

    const formattedContext = result.map((item) => ({
      label: item.Coluna,
      value: item.Valor,
    }));

    setContextData(formattedContext);
  };

  const handleGetDataStepTwo = async () => {
    if (rowSelected.length !== 2) return;

    const params = {
      1: rowSelected[0].ID_Arquivo,
      2: rowSelected[1].ID_Arquivo,
    };

    try {
      const [resp1, resp2] = await Promise.all([
        BizinBackend.executeProcedure(
          params,
          "SRM_Historico_Diferenca_Pedidos",
          csrfToken,
          access_token,
        ),
        BizinBackend.executeProcedure(
          params,
          "SRM_Historico_Diferenca_Pedidos_Itens",
          csrfToken,
          access_token,
        ),
      ]);

      const pedido = Array.isArray(resp1) ? resp1 : [];
      const itens = Array.isArray(resp2) ? resp2 : [];

      if (pedido.length === 0 && itens.length === 0) {
        setdataStepTwo({ pedido: [], itens: [] });
        setStep(2);
        return;
      }

      setdataStepTwo({ pedido, itens });
      setStep(2);
    } catch (error) {
      console.log("error ao carregar step 2", error);
    }
  };

  const handleNextStep = () => {
    handleGetDataStepTwo();
  };

  useEffect(() => {
    handleGetDataStepOne();
    handleGetFlow();
    handleGetContext();
  }, [ID_Arquivo, csrfToken, access_token]);

  const isDisabled = rowSelected.length !== MAX_SELECTION;

  return (
    <>
      {/* FLOW */}
      {flowData.length > 0 && (
        <div className="mt-3 mb-2">
          <CardFlow flowData={flowData} />
        </div>
      )}

      {/* CONTEXTO */}
      {contextData.length > 0 && (
        <div className="mb-3">
          <CardContext data={contextData} />
        </div>
      )}

      {step === 1 && (
        <>
          {dataStepOne.length < 2 ? (
            <div className="text-center mt-4">
              <span className="text-muted font-size-16 fw-semibold">
                Não existe histórico de pedidos reenviados
              </span>
            </div>
          ) : (
            <TableSimple
              dataKey={"ID_Arquivo"}
              data={dataStepOne}
              columnsList={[
                { field: "Numero_Pedido", header: "Número Pedido" },
                { field: "Data_Criacao", header: "Data Envio" },
                { field: "Valor_Total_Pedido", header: "Valor Total" },
                { field: "Quantidade_Itens", header: "Qtd. Itens" },
                { field: "Status", header: "Status" },
              ]}
              enableCheckbox
              enableCheckboxInHeader={false}
              maxSelectionPerCheckbox={MAX_SELECTION}
              callbackCheckboxSelected={setRowSelected}
            />
          )}
        </>
      )}

      {step === 2 &&
        (dataStepTwo.pedido.length > 0 || dataStepTwo.itens.length > 0 ? (
          <>
            {/* Tabela Pedido */}
            {dataStepTwo.pedido.length > 0 && (
              <TableSimple
                data={dataStepTwo.pedido}
                columnsList={[
                  { field: "Nome_Campo", header: "Nome" },
                  { field: "Valor_Pedido1", header: "Valor 1" },
                  { field: "Valor_Pedido2", header: "Valor 2" },
                ]}
              />
            )}

            {/* Tabela Itens */}
            {dataStepTwo.itens.length > 0 && (
              <TableSimple
                data={dataStepTwo.itens}
                columnsList={[
                  { field: "Nome_Campo", header: "Nome" },
                  { field: "Numero_Item", header: "Número" },
                  { field: "Valor_Pedido1", header: "Valor 1" },
                  { field: "Valor_Pedido2", header: "Valor 2" },
                ]}
              />
            )}
          </>
        ) : (
          <div className="text-center mt-4">
            <span className="text-muted font-size-16 fw-semibold">
              Nenhuma divergência encontrada entre os pedidos
            </span>
          </div>
        ))}

      {step === 1 && dataStepOne.length >= 2 && (
        <div className="w-100">
          <div className="d-flex justify-content-end align-items-center gap-2 mt-3">
            {!isModalPage && (
              <button
                className="fw-semibold"
                style={{
                  background: hover ? "#f1f3f5" : "transparent",
                  border: "none",
                  color: hover ? "#498ef2" : "#6c757d",
                  height: "32px",
                  padding: "0 12px",
                  boxShadow: "none",
                  outline: "none",
                  cursor: "pointer",
                }}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => {
                  window.close();
                  window.history.back();
                }}
              >
                Fechar
              </button>
            )}

            <button
              className="btn btn-comparar d-flex align-items-center gap-2 fw-semibold"
              disabled={isDisabled}
              onClick={handleNextStep}
              style={
                isDisabled
                  ? {
                      backgroundColor: "#D9D9D9",
                      borderColor: "#D9D9D9",
                      color: "#6C6C6C",
                      opacity: 1,
                      cursor: "not-allowed",
                    }
                  : {}
              }
            >
              Comparar!
            </button>
          </div>
        </div>
      )}

      {step === 2 && (
        <div className="w-100">
          <div className="d-flex align-items-end justify-content-end mt-3">
            <button
              className="btn btn-comparar fw-semibold d-flex align-items-center gap-2"
              onClick={() => {
                setStep(1);
                setRowSelected([]);
              }}
            >
              Voltar
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default GridBody;
